import React, {Component} from "react";
import PropTypes from "prop-types";
import {Redirect} from 'react-router';
import {NavLink} from 'react-router-dom';
import Loader from '../Loader'
import api from "../../api/Api";
import Checkbox from "@material-ui/core/Checkbox";

import ReactTable from "react-table";
import "react-table/react-table.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Datetime from "react-datetime";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import moment from "moment";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// core components
import GridItem from "components/Grid/GridItem.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import matchSorter from 'match-sorter';
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import LocalHospital from "@material-ui/icons/Assignment";
import SearchComponent from "components/Search/AutoCompletePatient.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';
import Slide from "@material-ui/core/Slide";
//import AlertBox from 'components/AlertBox/alertbox.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import GridContainer from "components/Grid/GridContainer.jsx";

import {
    mappingUI,
    dashboardRouter,
    isClinicMasterOrClinic,
    getClinicUserId, getDateConverter,
    getReportTypes
} from '../../util/globalHelper';
import Permissions from '../../util/globalPermissions';
import DialogContent from "@material-ui/core/DialogContent";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    AutoCompleteClass: {
        width: '100%',
        padding: 0,
        margin: '20px 0',
        height: 0,
        position: 'inherit'
    }
};
function Transition(props) {
    return <Slide direction="down" {...props} />;
}

class AllPrescriptionTemplate extends Component {
    constructor() {
        super();
        this.state = {
            data: null,
            clinicsData: null,
            simpleSelect: "",
            doctorsData: null,
            start_date: moment().format('YYYY-MM-DD'),
            end_date: moment().format('YYYY-MM-DD'),
            clinic_id: "",
            doctor_id: "Complaints",
            patientId: "",
            type: "",
            open: true,
            alert: null,
            notFound: null,
            editTitle: "",
            editType: "",
            editDescription: "",
            selectedID: "",
            setOpen: false,
            openModal: false,
            addNewModal: false,
            classicModal: false,
            statusText: true,
            deleteModal: false,
            newText: "",
            newType: ""
        };
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.searchOnFilter = this.searchOnFilter.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
        this.CreateAlert = this.CreateAlert.bind(this)
        this.onChange = this.onChange.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleOpen = this.handleOpen.bind(this)
        this.EditAlert = this.EditAlert.bind(this)
        this.addNewNote = this.addNewNote.bind(this)

    }

    handleChangeStartDate(event) {
        this.setState({start_date: event.format('YYYY-MM-DD')});
    }

    handleChangeEndDate(event) {
        this.setState({end_date: event.format('YYYY-MM-DD')});
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };


    CallReadApi = () => {
        api.getReportConfig({}).then(json => {
            this.setState({
                data: json.data.data
            })
        }).catch(error => {
            this.setState({notFound: error, data: []})
        });
        isClinicMasterOrClinic() === "" || isClinicMasterOrClinic() ?
            api.listClinics().then(json => {
                this.setState({clinicsData: json.data.data})
            }) : this.setState({clinicsData: {}});
        // api.getAllDoctors().then(json => {
        //     this.setState({doctorsData: json.data.data})
        // });
        this.setState({clinic_id: getClinicUserId()})
    }

    componentDidMount() {
        this.CallReadApi();
    }

    searchOnFilter() {
        this.setState({data: null});
        var postBody = {
            type: this.state.doctor_id
        };
        api.getClinicalNotes(postBody)
            .then(json => {
                this.setState({
                    data: json.data.data
                })
            });
    }


    getSuggestionValue = (suggestion) => {
        this.setState({
            patientId: suggestion._id,

        });
        return suggestion.user_id.name


    };

    deleteTemplate(id) {
        var postBody = {
            "_id": id, "updated_object": {
                "active": false
            }
        };
        api.updateReportConfig(postBody)
            .then(json => {
                window.location.reload();
            });
    }

    onChangeStatus(e) {
        this.setState({statusText: e.target.checked});

    }


    handleOpen() {
        this.setState({setOpen: true});
    };

    handleClose() {
        this.setState({setOpen: false});
    };


    hideAlert() {
        this.setState({alert: null})
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };


    CreateAlert(title, type, description) {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{"Report Config Text"}</DialogTitle>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12} className="centerDiv" style={{margin: '8px 10px'}}>
                            <FormControl
                                fullWidth> <CustomInput
                                labelText="Title"
                                // id="email"
                                formControlProps={{
                                    fullWidth: true,
                                }}
                                inputProps={{
                                    // onChange: event =>
                                    //     this.change(event, "email", "email"),
                                    value: title,
                                    disabled: true

                                }}
                            /></FormControl>
                        </GridItem> <GridItem xs={12} sm={12} md={12} className="centerDiv"
                                              style={{margin: '8px 10px'}}>
                        <FormControl
                            fullWidth> <CustomInput
                            labelText="Type"
                            // id="email"
                            formControlProps={{
                                fullWidth: true,
                            }}
                            inputProps={{
                                // onChange: event =>
                                //     this.change(event, "email", "email"),
                                value: type,
                                disabled: true

                            }}
                        /></FormControl>
                    </GridItem>
                        <GridItem xs={12} sm={12} md={12} className="centerDiv" style={{margin: '8px 10px'}}>
                            <FormControl
                                fullWidth> <CustomInput
                                labelText="Description"
                                // id="email"
                                formControlProps={{
                                    fullWidth: true,
                                }}
                                inputProps={{
                                    // onChange: event =>
                                    //     this.change(event, "email", "email"),
                                    value: description,
                                    disabled: true

                                }}
                            /></FormControl>
                        </GridItem>
                    </GridContainer><br/>
                    <DialogActions style={{margin: '8px auto'}}>


                        {/*<Button color="danger" onClick={() => {*/}
                        {/*// this.deleteRecord(id)*/}
                        {/*}}>*/}
                        {/*Edit*/}
                        {/*</Button>*/}
                        <Button onClick={this.hideAlert}>
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        });
    }

    EditAlert(id, text) {
        this.setState({editText: text}, () => {
            this.setState({
                alert: (
                    <Dialog
                        open={this.state.open}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">{"Medication Edit Text"}</DialogTitle>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12} className="centerDiv" style={{margin: '8px 10px'}}>
                                <FormControl
                                    fullWidth> <CustomInput
                                    labelText="Text"
                                    // id="email"
                                    formControlProps={{
                                        fullWidth: true,
                                    }}
                                    inputProps={{
                                        onChange: event =>
                                            this.onChange(event),
                                        value: this.state.editText

                                    }}
                                /></FormControl></GridItem></GridContainer><br/>
                        <DialogActions style={{margin: '8px auto'}}>


                            <Button color="danger" onClick={() => {
                                this.editText(id)
                            }}>
                                Save
                            </Button>
                            <Button onClick={this.hideAlert}>
                                Cancel
                            </Button>
                        </DialogActions>
                    </Dialog>
                )
            });
        })
    }

    addNewNote() {
        var postBody = {"text": this.state.newText, "type": this.state.newType};
        if (this.state.newText !== "" && this.state.newType !== "") {
            api.createClinicalNotes(postBody)
                .then(json => {
                    window.location.reload();
                });
        }
    }

    editText(id) {
        var postBody = {
            "_id": id,
            "updated_object": {
                "title": this.state.editTitle,
                "type": this.state.editType,
                "description": this.state.editDescription
            }
        };
        api.updateReportConfig(postBody)
            .then(json => {
                window.location.reload();
            });
    }

    onChange(e) {
        this.setState({[e.target.name]: e.target.value});
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    render() {
        const {data, clinicsData, doctorsData} = this.state;
        const {classes} = this.props;
        if (this.state.data !== null && this.state.clinicsData)
            return (
                <div>
                    {this.state.alert}
                    <Grid container>
                        {/*<GridItem xs={12} sm={12} md={2}>*/}
                        {/*<Button block color="warning" onClick={() => this.handleClickOpen("addNewModal")}>*/}
                        {/*<Icon>add</Icon>*/}
                        {/*<span style={{paddingLeft: 10}}>ADD NEW</span>*/}
                        {/*</Button>*/}
                        {/*</GridItem>*/}
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <LocalHospital style={{marginTop: 10}}/>
                                            </GridItem>

                                            <GridItem>
                                                <h4 className={classes.cardTitleWhite}>Report Config</h4>
                                                <p className={classes.cardCategoryWhite}>
                                                    List of all Report Config
                                                </p>
                                            </GridItem>
                                        </GridContainer>
                                    </CardText>
                                </CardHeader>
                                <CardBody>
                                    {/*<div>*/}


                                    {/*<GridContainer>*/}
                                    {/*<GridItem xs={12} sm={4} md={4} className="centerDiv">*/}

                                    {/*</GridItem>*/}
                                    {/*<GridItem xs={12} sm={4} md={4} className="centerDiv">*/}
                                    {/*<FormControl*/}
                                    {/*fullWidth*/}
                                    {/*className={classes.selectFormControl}>*/}
                                    {/*<InputLabel*/}
                                    {/*htmlFor="simple-select"*/}
                                    {/*className={classes.selectLabel}>*/}
                                    {/*Select Type*/}
                                    {/*</InputLabel>*/}
                                    {/*<Select*/}
                                    {/*MenuProps={{*/}
                                    {/*className: classes.selectMenu*/}
                                    {/*}}*/}
                                    {/*classes={{*/}
                                    {/*select: classes.select*/}
                                    {/*}}*/}
                                    {/*value={this.state.doctor_id}*/}
                                    {/*onChange={this.onChangeSelect}*/}
                                    {/*inputProps={{*/}
                                    {/*name: "doctor_id",*/}
                                    {/*id: "doctor_id"*/}
                                    {/*}}*/}
                                    {/*>*/}
                                    {/*<MenuItem*/}
                                    {/*disabled*/}
                                    {/*classes={{*/}
                                    {/*root: classes.selectMenuItem*/}
                                    {/*}}>*/}
                                    {/*Select Type*/}
                                    {/*</MenuItem>*/}
                                    {/*<MenuItem key={Math.random()}*/}
                                    {/*classes={{root: classes.selectMenuItem}}*/}
                                    {/*style={{height: "1.8em"}}*/}
                                    {/*value={"Complaints"}>Complaints</MenuItem>*/}
                                    {/*<MenuItem key={Math.random()}*/}
                                    {/*classes={{root: classes.selectMenuItem}}*/}
                                    {/*style={{height: "1.8em"}}*/}
                                    {/*value={"Diagnosis"}>Diagnosis</MenuItem>*/}
                                    {/*<MenuItem key={Math.random()}*/}
                                    {/*classes={{root: classes.selectMenuItem}}*/}
                                    {/*style={{height: "1.8em"}}*/}
                                    {/*value={"Observation"}>Observation</MenuItem>*/}

                                    {/*</Select>*/}
                                    {/*</FormControl>*/}
                                    {/*</GridItem>*/}
                                    {/*<GridItem xs={12} sm={4} md={4} className="centerDiv">*/}

                                    {/*</GridItem>*/}
                                    {/*</GridContainer>*/}
                                    {/*<br/>*/}

                                    {/*<GridContainer>*/}
                                    {/*<GridItem xs={12} sm={12} md={12} className="centerDiv">*/}
                                    {/*<Button color="warning" size="lg"*/}
                                    {/*onClick={this.searchOnFilter}>Search</Button>*/}
                                    {/*</GridItem>*/}
                                    {/*</GridContainer>*/}

                                    {/*</div>*/}
                                    <br/>
                                    {data !== null && data.length >= 0 ?
                                        <ReactTable
                                            data={data}
                                            filterable
                                            defaultFilterMethod={(filter, row) =>
                                            String(row[filter._id]) === filter.value}
                                            columns={[
                                                {
                                                    columns: [
                                                        {
                                                            Header: "Type",
                                                            accessor: "type",
                                                            // Cell: ({index}) =>
                                                            //     (<div>
                                                            //             <p style={{cursor: 'pointer'}}>
                                                            //                 {data[index].patient_id ? data[index].patient_id.user_id.name : "No Name"}
                                                            //             </p>
                                                            //         </div>
                                                            //     ),
                                                            filterMethod: (filter, rows) =>
                                                                matchSorter(rows, filter.value, {keys: ["type"]}),
                                                            filterAll: true
                                                        }, {
                                                            Header: "Title",
                                                            accessor: "title",
                                                            filterMethod: (filter, rows) =>
                                                                matchSorter(rows, filter.value, {keys: ["title"]}),
                                                            filterAll: true
                                                            // filterMethod: (filter, rows) =>
                                                            //     matchSorter(rows, filter.value, {keys: ["paid"]}),
                                                            // filterAll: true

                                                        },
                                                        {
                                                            Header: "Description",
                                                            accessor: "description",
                                                            filterMethod: (filter, rows) =>
                                                                matchSorter(rows, filter.value, {keys: ["description"]}),
                                                            filterAll: true
                                                            // filterMethod: (filter, rows) =>
                                                            //     matchSorter(rows, filter.value, {keys: ["paid"]}),
                                                            // filterAll: true

                                                        },
                                                        {
                                                            Header: 'Actions',
                                                            id: 'request_state',
                                                            filterable: false,
                                                            sortable: false,
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                    <Tooltip
                                                                        id="tooltip-top"
                                                                        title="View"
                                                                        placement="bottom"
                                                                        classes={{tooltip: classes.tooltip}}>
                                                                        <Button type="button" color="info"
                                                                                style={{
                                                                                    padding: 8,
                                                                                    marginLeft: '10%'
                                                                                }}
                                                                                onClick={() => {
                                                                                    this.CreateAlert(`${data[index].title}`, `${data[index].type}`, `${data[index].description}`);
                                                                                }}>
                                                                            <Icon
                                                                                style={{fontSize: 20}}>info</Icon>
                                                                        </Button>
                                                                    </Tooltip>
                                                                    <Tooltip
                                                                        id="tooltip-top"
                                                                        title="Edit"
                                                                        placement="bottom"
                                                                        classes={{tooltip: classes.tooltip}}>
                                                                        <Button type="button" color="success"
                                                                                style={{
                                                                                    padding: 8,
                                                                                    marginLeft: '10%'
                                                                                }}
                                                                                onClick={() => {
                                                                                    this.setState({
                                                                                        selectedID: `${data[index]._id}`,
                                                                                        editType: `${data[index].type}`,
                                                                                        editTitle: `${data[index].title}`,
                                                                                        editDescription: `${data[index].description}`
                                                                                    }, () => {
                                                                                        this.handleClickOpen("classicModal")
                                                                                    })
                                                                                }}>
                                                                            <Icon style={{fontSize: 20}}>info</Icon>
                                                                        </Button>
                                                                    </Tooltip>
                                                                    <Tooltip
                                                                        id="tooltip-top"
                                                                        title="Remove"
                                                                        placement="bottom"
                                                                        classes={{tooltip: classes.tooltip}}>
                                                                        <Button type="button" color="danger"
                                                                                style={{
                                                                                    padding: 8,
                                                                                    marginLeft: '5%'
                                                                                }}
                                                                                onClick={() => {
                                                                                    this.setState({
                                                                                        selectedID: `${data[index]._id}`,
                                                                                        statusText: data[index].active
                                                                                    }, () => {
                                                                                        this.handleClickOpen("deleteModal")
                                                                                    })
                                                                                }}>
                                                                            <Icon
                                                                                style={{fontSize: 20}}>close</Icon>
                                                                        </Button></Tooltip>
                                                                </div>)
                                                        }
                                                    ]
                                                }
                                            ]}
                                            defaultPageSize={10}
                                            className="-striped -highlight"
                                        />
                                        : null
                                    }
                                </CardBody>
                            </Card>
                        </GridItem>
                    </Grid>
                    <Dialog
                        classes={{
                            root: classes.center + " " + classes.modalRoot,
                            paper: classes.modal
                        }}
                        open={this.state.classicModal}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => this.handleClose("classicModal")}
                        aria-labelledby="classic-modal-slide-title"
                        aria-describedby="classic-modal-slide-description"
                    >
                        <DialogTitle
                            id="classic-modal-slide-title"
                            disableTypography
                            className={classes.modalHeader}
                        >
                            <h4 className={classes.modalTitle}>Edit Report Config Modal</h4>
                        </DialogTitle>
                        <DialogContent
                            id="classic-modal-slide-description"
                            className={classes.modalBody}
                        >
                            <FormControl
                                fullWidth> <CustomInput
                                labelText="Title"
                                // id="email"
                                formControlProps={{
                                    fullWidth: true,
                                }}
                                inputProps={{
                                    onChange: event =>
                                        this.onChange(event),
                                    value: this.state.editTitle,
                                    name: "editTitle"
                                }}
                            /></FormControl>
                            <GridItem xs={12} sm={12} md={12} className="centerDiv" style={{margin: '8px 0px'}}>
                                <FormControl
                                    fullWidth
                                    className={classes.selectFormControl}
                                    style={{marginTop: 10}}>
                                    <InputLabel
                                        htmlFor="reportType"
                                        className={classes.selectLabel}>
                                        Report Type
                                    </InputLabel>
                                    <Select
                                        MenuProps={{
                                            className: classes.selectMenu
                                        }}
                                        classes={{
                                            select: classes.select
                                        }}
                                        value={this.state.editType}
                                        onChange={this.handleSimple}
                                        inputProps={{
                                            name: "editType",
                                            id: "editType"
                                        }}
                                    >
                                        <MenuItem
                                            disabled
                                            classes={{
                                                root: classes.selectMenuItem
                                            }}>
                                            Report Type
                                        </MenuItem>
                                        {getReportTypes().map(item => {
                                            return <MenuItem key={Math.random()}
                                                             classes={{root: classes.selectMenuItem}}
                                                             style={{height: "1.8em"}}
                                                             value={item}>{item}</MenuItem>
                                        })})}
                                    </Select>
                                </FormControl>

                            </GridItem>
                            <GridItem xs={12} sm={12} md={12} className="centerDiv"
                                      style={{margin: '8px 0px'}}>
                                <FormControl
                                    fullWidth> <CustomInput
                                    labelText="Description"
                                    // id="email"
                                    formControlProps={{
                                        fullWidth: true,
                                    }}
                                    inputProps={{
                                        onChange: event =>
                                            this.onChange(event),
                                        value: this.state.editDescription,
                                        name: "editDescription"

                                    }}
                                /></FormControl>
                            </GridItem>
                        </DialogContent>
                        <DialogActions className={classes.modalFooter}>
                            {/*<Button color="transparent">Nice Button</Button>*/}
                            <Button color="danger" onClick={() => {
                                this.editText(this.state.selectedID)
                            }}>
                                Save
                            </Button>
                            <Button
                                onClick={() => this.handleClose("classicModal")}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        classes={{
                            root: classes.center + " " + classes.modalRoot,
                            paper: classes.modal
                        }}
                        open={this.state.deleteModal}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => this.handleClose("deleteModal")}
                        aria-labelledby="classic-modal-slide-title"
                        aria-describedby="classic-modal-slide-description"
                    >
                        <DialogTitle
                            id="classic-modal-slide-title"
                            disableTypography
                            className={classes.modalHeader}
                        >
                            <h4 className={classes.modalTitle}>Delete</h4>
                        </DialogTitle>
                        <DialogContent
                            id="classic-modal-slide-description"
                            className={classes.modalBody}
                        >
                            Are you sure want to delete?

                            {/*<FormControl*/}
                            {/*fullWidth>*/}
                            {/*<Checkbox*/}
                            {/*checked={this.state.statusText}*/}
                            {/*onChange={(e) => this.onChangeStatus(e)}*/}
                            {/*value="checkedA"*/}
                            {/*color={"primary"}*/}
                            {/*inputProps={{*/}
                            {/*'aria-label': 'primary checkbox',*/}
                            {/*}}*/}
                            {/*/>*/}
                            {/*Active*/}
                            {/*</FormControl>*/}
                        </DialogContent>
                        <DialogActions className={classes.modalFooter}>
                            {/*<Button color="transparent">Nice Button</Button>*/}
                            <Button color="danger" onClick={() => {
                                this.deleteTemplate(this.state.selectedID)
                            }}>
                                Delete
                            </Button>
                            <Button
                                onClick={() => this.handleClose("deleteModal")}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        classes={{
                            root: classes.center + " " + classes.modalRoot,
                            paper: classes.modal
                        }}
                        open={this.state.addNewModal}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => this.handleClose("addNewModal")}
                        aria-labelledby="classic-modal-slide-title"
                        aria-describedby="classic-modal-slide-description"
                    >
                        <DialogTitle
                            id="classic-modal-slide-title"
                            disableTypography
                            className={classes.modalHeader}
                        >
                            <h4 className={classes.modalTitle}>Add</h4>
                        </DialogTitle>
                        <DialogContent
                            id="classic-modal-slide-description"
                            className={classes.modalBody}
                        >
                            <GridItem xs={12} className="centerDiv">
                                <FormControl
                                    fullWidth
                                    className={classes.selectFormControl}>
                                    <InputLabel
                                        htmlFor="simple-select"
                                        className={classes.selectLabel}>
                                        Select Type
                                    </InputLabel>
                                    <Select
                                        MenuProps={{
                                            className: classes.selectMenu
                                        }}
                                        classes={{
                                            select: classes.select
                                        }}
                                        value={this.state.newType}
                                        onChange={this.onChangeSelect}
                                        inputProps={{
                                            name: "newType",
                                            id: "newType"
                                        }}
                                    >
                                        <MenuItem
                                            disabled
                                            classes={{
                                                root: classes.selectMenuItem
                                            }}>
                                            Select Type
                                        </MenuItem>
                                        <MenuItem key={Math.random()}
                                                  classes={{root: classes.selectMenuItem}}
                                                  style={{height: "1.8em"}}
                                                  value={"Complaints"}>Complaints</MenuItem>
                                        <MenuItem key={Math.random()}
                                                  classes={{root: classes.selectMenuItem}}
                                                  style={{height: "1.8em"}}
                                                  value={"Diagnosis"}>Diagnosis</MenuItem>
                                        <MenuItem key={Math.random()}
                                                  classes={{root: classes.selectMenuItem}}
                                                  style={{height: "1.8em"}}
                                                  value={"Observation"}>Observation</MenuItem>

                                    </Select>
                                </FormControl>
                            </GridItem>

                            <FormControl
                                fullWidth> <CustomInput
                                labelText="Text"
                                // id="email"
                                formControlProps={{
                                    fullWidth: true,
                                }}
                                inputProps={{
                                    onChange: event =>
                                        this.onNewChange(event),
                                    value: this.state.newText

                                }}
                            /></FormControl>
                        </DialogContent>
                        <DialogActions className={classes.modalFooter}>
                            <Button color="danger" onClick={() => {
                                this.addNewNote();
                                this.handleClose("addNewModal")
                            }}>
                                Save
                            </Button>
                            <Button
                                onClick={() => this.handleClose("addNewModal")}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>

                </div>
            );
        else return (
            <div>
                <Loader/>
            </div>
        )
    }

    handleClickOpen(modal) {
        var x = [];
        x[modal] = true;
        this.setState(x);
    }

    handleClose(modal) {
        var x = [];
        x[modal] = false;
        this.setState(x);
    }

    onNewChange(e) {
        this.setState({newText: e.target.value});
    }
}
export default withStyles(styles)(AllPrescriptionTemplate);



// WEBPACK FOOTER //
// ./src/components/Data/AllReportConfig.jsx